import { render, staticRenderFns } from "./FormAdditionalServices.vue?vue&type=template&id=5596a2e0&"
import script from "./FormAdditionalServices.vue?vue&type=script&lang=js&"
export * from "./FormAdditionalServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports